import { render, staticRenderFns } from "./DataTablePengaturanSKP.vue?vue&type=template&id=3a4eec22&scoped=true&"
import script from "./DataTablePengaturanSKP.vue?vue&type=script&lang=js&"
export * from "./DataTablePengaturanSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4eec22",
  null
  
)

export default component.exports